import React from 'react';
import { StyledTimestamp, StyledFailureStatus, StyledSpinnerForChatBubble } from './SharedChatBubble.styled';
import { formatTimestamp } from './helpers';
export const ChatBubbleStatus = ({ author, state, time, errorMessage }) => {
    const parsedDate = new Date(time);
    if (author === 'guest') {
        switch (state) {
            case 'failed':
                return React.createElement(StyledFailureStatus, { author: author }, errorMessage);
            default:
                return React.createElement(StyledTimestamp, { author: author }, time && formatTimestamp(parsedDate));
        }
    }
    switch (state) {
        case 'failed':
            return React.createElement(StyledFailureStatus, { author: author }, errorMessage);
        case 'sending':
            return React.createElement(StyledSpinnerForChatBubble, null);
        case 'sent':
            return React.createElement(StyledTimestamp, { author: author }, time && formatTimestamp(parsedDate));
        default:
            return null;
    }
};
//# sourceMappingURL=SharedChatBubbleStatus.js.map